import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes, useLocation } from "react-router-dom";
import { useEffect, Suspense } from "react";
import routes from "./config";
import PageTransition from "../components/feature/PageTransition";
import LangRouteHandler from "../components/feature/LangRouteHandler";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return (
    <LangRouteHandler>
      <Suspense fallback={<div className="min-h-screen bg-white" />}>
        <PageTransition key={location.pathname}>
          {element}
        </PageTransition>
      </Suspense>
    </LangRouteHandler>
  );
}